"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCardtraderAttributeErrors = void 0;
var stripQuotes = function (s) { return s.trim().replace(/^\\?"|\\?"$/g, ''); };
var parseCardtraderAttributeErrors = function (error) {
    var issues = [];
    var seen = new Set();
    var notEditableRe = /`(\w+)` is not editable\. You specified '([^']*)' as value\. The only acceptable value is '([^']*)'/g;
    var m;
    while ((m = notEditableRe.exec(error))) {
        var key = "".concat(m[1], "|").concat(m[2], "|").concat(m[3]);
        if (seen.has(key))
            continue;
        seen.add(key);
        issues.push({ attribute: m[1], submitted: m[2], expected: [m[3]] });
    }
    var acceptsRe = /(\w+) accepts a value within \[([^\]]*)\]\. You specified '([^']*)'/g;
    while ((m = acceptsRe.exec(error))) {
        var expected = m[2]
            .split(',')
            .map(function (v) { return stripQuotes(v); })
            .filter(Boolean);
        var key = "".concat(m[1], "|").concat(m[3], "|").concat(expected.join(','));
        if (seen.has(key))
            continue;
        seen.add(key);
        issues.push({ attribute: m[1], submitted: m[3], expected: expected });
    }
    return issues;
};
exports.parseCardtraderAttributeErrors = parseCardtraderAttributeErrors;
//# sourceMappingURL=cardtraderErrors.js.map